
    <spaq-choose-method (selectMethod)="onSelectMethod($event)"></spaq-choose-method>
  


// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/register/containers/register-page.component.ts.RegisterPageComponent.html